import _ from "lodash"
import environmentVariables from "shared/enviromentVariables/index.js.erb"

export function allPlans() {
    return environmentVariables.plans
}

export function isStarterPlan(user) {
    if (user) {
        const plans = Object.values(allPlans())
        const minPlanLevel = _.minBy(plans, "level").level
        const minLevelPlans = plans.filter((plan) => plan.level === minPlanLevel).map((plan) => plan.id)
        return minLevelPlans.includes(user.plan_id)
    } else {
        return false
    }
}

export function isProfilePlan(user) {
    if (user) {
        if (user.test_user) return true
        const plans = Object.values(allPlans())
        const minPlanLevel = _.minBy(plans, "level").level
        const minLevelPlans = plans.filter((plan) => plan.level === (minPlanLevel + 1)).map((plan) => plan.id)
        return minLevelPlans.includes(user.plan_id)
    } else {
        return false
    }
}

export function isIndividualPlan(user) {
    if (user) {
        const plans = Object.values(allPlans())
        const maxPlanLevel = _.maxBy(plans, "level").level
        const maxLevelPlans = plans.filter((plan) => plan.level === (maxPlanLevel - 1)).map((plan) => plan.id)
        return maxLevelPlans.includes(user.plan_id)
    } else {
        return false
    }
}

export function viewRem(user) {
    return (isIndividualPlan(user) || isInstitutionalPlan(user) || isOpenRemunerationPlan(user))
}

export function isPublicUser(user) {
    if (user) {
        return user.plan_id === environmentVariables.public_plan
    } else {
        return false
    }
}

export function isBasicPlanUser(user) {
    return (isPublicUser(user) || isStarterPlan(user) || isProfilePlan(user))
}

export function isMoreThanBasicPlanUser(user) {
    return (isBasicPlanUser(user) || isProfilePlan(user))
}

export function isAdVisible(user) {
    return (isPublicUser(user) || isStarterPlan(user) || isProfilePlan(user))
}

export function isJobPostPlan(user) {
    if (user) {
        return user.plan_id === environmentVariables.job_post_plan
    } else {
        return false
    }
}

export function isOpenRemunerationPlan(user) {
    if (user) {
        if (user.open_rem_super_user) return true
        return user.plan_id === environmentVariables.remuneration_plan
    } else {
        return false
    }
}

// Used internally only
function isAdvancedFeatureVisible(user) {
    if (user) {
        return user.view_advanced_feature
    } else {
        return false
    }
}

export function viewAdvancedFeatureVisible(user) {
    return (isAdvancedFeatureVisible(user) && (isIndividualPlan(user) || isInstitutionalPlan(user)))
}

export function viewJobFeatureVisible(user) {
    return (isIndividualPlan(user) || isInstitutionalPlan(user) || isJobPostPlan(user))
}

export function isInstitutionalPlan(user) {
    if (user) {
        if (user.super_user) return true
        const plans = Object.values(allPlans())
        const maxPlanLevel = _.maxBy(plans, "level").level
        const maxLevelPlans = plans.filter((plan) => plan.level === maxPlanLevel).map((plan) => plan.id)
        return maxLevelPlans.includes(user.plan_id)
    } else {
        return false
    }
}

export function isInstitutionalParentPlan(user) {
    if (user) {
        return isInstitutionalPlan(user) && user.parent_account
    } else {
        return false
    }
}

export function isRealInstitutionalParentPlan(user) {
    if (user) {
        return isInstitutionalParentPlan(user) && !user.super_user && !user.test_user
    } else {
        return false
    }
}